export const allAvatarPartIds: { [key: string]: string } = {
  defaultAvatar: "default-avatar",
  userAvatar: "user-avatar",
  imageAvatar: "image-avatar",
  avatarWrapper: "avatar-wrapper",
  avatarBadge: "avatar-badge",
};
